import { Component, QueryList, ViewChildren, Input } from '@angular/core';
import { ApiError, MessageService } from '../../../../../../core';

import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ProdutividadeFilter, TipoClassificacao } from '../../../adapters';
import { ProdutividadeClassificacoesKPITableComponent } from '../../../components/classificacoes-table';
import { ProdutividadeHttpService } from '../../../services';
import { ProdutividadeClassificacoesKPIWidgetState } from './produtividade-classificacoes-kpi-widget-state.interface';
import { ProdutividadeClassificacoesKPIWidgetStateService } from './produtividade-classificacoes-kpi-widget-state.service';

@Component({
    selector: 'sgt-produtividade-classificacoes-kpi-widget',
    templateUrl: './produtividade-classificacoes-kpi-widget.component.html',
    styleUrls: ['./produtividade-classificacoes-kpi-widget.component.less'],
    providers:[
        ProdutividadeClassificacoesKPIWidgetStateService
    ]
})
export class ProdutividadeClassificacoesKPIWidgetComponent {
    /** ID do component */
    @Input() id: string;
    /** Title do widget */
    @Input() title = 'Segmentos';
    /** Subtitle do widget */
    @Input() subtitle: string = null;
    /** State do component */
    state: ProdutividadeClassificacoesKPIWidgetState;
    /** Subscription do state do component */
    private state$: Subscription;
    /** Flag que indica se está carregando a view */
    isLoading$: Observable<boolean>;

    /** Query List das tables das classificações */
    @ViewChildren('table') tables: QueryList<ProdutividadeClassificacoesKPITableComponent>;

    constructor(private messageService: MessageService,
                private produtividadeClassificacoesKPIWidgetStateService: ProdutividadeClassificacoesKPIWidgetStateService,
                private produtividadeHttpService: ProdutividadeHttpService) { }

    ngOnInit(): void {
        this.initState();
    }

    /** Inicializando o state do component */
    private initState() {
        // State
        this.state$ = this.produtividadeClassificacoesKPIWidgetStateService.init(true, this.id).subscribe(state => this.state = state);
        // IsLoading
        this.isLoading$ = this.produtividadeClassificacoesKPIWidgetStateService.isLoading$;
    }

    /** Carrega o dash */
    load(filter: ProdutividadeFilter) {
        try {
            this.produtividadeClassificacoesKPIWidgetStateService.setIsLoading(true);
            this.produtividadeClassificacoesKPIWidgetStateService.setPeriodicidade(filter?.periodicidade.periodicidade);
            this.produtividadeHttpService.get(filter)
                .pipe(take(1))
                .subscribe(
                    produtividade => {
                        this.produtividadeClassificacoesKPIWidgetStateService.setData(produtividade);

                        setTimeout(() => {
                            this.setTabAtual();
                            this.tables?.forEach(table => table.show());
                        }, 0);
                    },
                    (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                    () => this.produtividadeClassificacoesKPIWidgetStateService.setIsLoading(false)
                );
        } catch (error) {
            this.messageService.error('Tente atualizar a página e se o erro persistir entre em contato com o suporte', `Erro ao carregar os KPI's de Produtividade Mensais`, error);
        }
    }

    /** Ao clicar na tab */
    onTabClick(tipoClassificacao: TipoClassificacao) {
        this.produtividadeClassificacoesKPIWidgetStateService.setTipoClassificacaoAtual(tipoClassificacao);
        jQuery(window).trigger('resize');
    }

    /** Seta a tab no tipo de classificação atualmente visívil */
    setTabAtual() {
        if (!this.state.tipoClassificacaoAtual) {
            return;
        }
        jQuery(`[data-target='#produtividadeClassificacoesKPIWidget_${this.state.tipoClassificacaoAtual.id}']`).trigger('click');
        jQuery(window).trigger('resize');
    }

    ngOnDestroy(): void {
        this.tables = null;
        this.state$?.unsubscribe();
    }
}
